import { DialogContent, DialogTitle } from "@material-ui/core";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader";
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import ClientHelper from "core/ClientHelper";
import DateHelper from "core/DateHelper";
import PropTypes from "prop-types";
import React, { Component } from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import CustomerComponent from "views/Components/CustomerComponent.jsx";
import { GenericCheckInput, GenericDateInput, GenericDialog, GenericDialogActions, GenericExpansionPanel, GenericGrid, GenericLabel, GenericSelectInput, GenericTextInput, GenericTitle } from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";
import ParameterComponent from "views/Components/ParameterComponent";
import { GridColumnType, ProgramCodes } from "views/Constants/Constant";


class IncorrectEmbossCards extends Component {
	constructor(props) {
		super(props);

		this.initialModel = {
			Id: 0,
			UniqueClientId: ClientHelper.IsClient() ? ClientHelper.GetClientRowId() : undefined,
			IsMainCard: true,
			ProgramCode: "",
			CardIssuingReasonTypeId: 0,
			EmbossStatusId: 0,
			ProductId: 0,
			StartDate: DateHelper.GetLocalDateAsUtc(),
			EndDate: DateHelper.GetLocalDateAsUtc(),
		};

		this.state = {
			model: this.initialModel,
			list: [],
			isLoading: false,
			vModel: {},
			reEmbossList: [],
			reReasonEmbosList: [],
			isReEmbossDialogOpen: false,
			isReasonReEmbossDialogOpen: false
		}

		this.emptyObject = {};

		this.maxLength26 = { maxLength: 26 };

		this.parameterUniqueClientId = {
			UniqueClientId: ClientHelper.IsClient() ? ClientHelper.GetClientId() : undefined
		};

		this.renderItemUniqueClient = {};
		this.renderItemCard = {};
		this.parameterProduct = {};

		this.ReasonEmbossColumns =
			[
				{
					Header: "Is Succeded",
					accessor: "IsSucceded",
					Cell: row => (
						<div>{row.value == true ? "Yes" : "No"}</div>
					)
				},
				{
					Header: "Masked Card Number",
					accessor: "MaskedCardNumber"
				},
				{
					Header: "Error Description",
					accessor: "ErrorDescription"
				},

			];

		this.DetailColumns =
			[
				{
					Header: "Create Date",
					accessor: "InsertDateTime",
					type: GridColumnType.DateTimeUtc
				},
				{
					Header: "Card Id",
					accessor: "CardId"
				},
				{
					Header: "Client",
					accessor: "ClientName"
				},
				{
					Header: "Customer Name",
					accessor: "CustomerName"
				},
				{
					Header: "Product Name",
					accessor: "ProductName"
				},
				{
					Header: "Emboss Name",
					accessor: "EmbossName1"
				},
				{
					Header: "Usage Limit",
					accessor: "CardUsageLimit",
					type: GridColumnType.Money
				},
				{
					Header: "Issuing Reason Type",
					accessor: "IssuingReasonType",
				},
				{
					Header: "Emboss Status",
					accessor: "EmbossStatusName",
				},
				{
					Header: "Emboss File",
					accessor: "FileName",
				},
				{
					Header: "Emboss File Create Date",
					accessor: "EmbossFileCreateDate",
					type: GridColumnType.Date
				},
				{
					Header: "Plastic Type",
					accessor: "PlasticTypeDesc",
				},
				{
					Header: "Product Brand",
					accessor: "ProductBrand",
				},
				{
					Header: "Bin Description",
					accessor: "BinDesc",
				}
				,
				{
					Header: "Is No Name Card",
					accessor: "IsNoNameCard",
					Cell: row => (
						<div>{row.value == true ? "Yes" : "No"}</div>
					)
				}
			];

		this.Columns = [
			...this.ReasonEmbossColumns,
			...this.DetailColumns
		];
	}




	componentDidMount() {
		this.props.setAppLeftTitle("Incorrect Emboss Cards");
		this.props.setAppCenterTitle("CARD MANAGEMENT SYSTEM");
	}

	HandleChange = (name, newValue, data) => {
		const model = { ...this.state.model };
		if (name === "Customer") {
			if (newValue) {
				model.ClientCustomerId = newValue.Id;
				model.CustomerNumber = newValue.CustomerNumber;
			} else {
				delete model.ClientCustomerId;
				delete model.CustomerNumber;
			}
		}
		if (name === "UniqueClientId") {
			delete model.ClientCustomerId;
			delete model.CustomerNumber;
		}
		if (name === "CardId" && data) {
			model.EmbossName = data.CardEmbossName;
		}

		model[name] = newValue;
		this.setState({ model });
	}

	HandleClear = () => {
		this.setState({ model: { ...this.initialModel }, isEdit: false, index: -1, reEmbossList: [] });
	}

	HandleSearch = () => {
		if (!this.Validate()) {
			return;
		}
		const model = { ...this.state.model };
		this.setState({ isLoading: true });
		Proxy.POST(
			"/prepaidapi/v1.0/CardRequest/IncorrectEmbossCardSearch",
			model,
			(responseData) => {
				this.setState({ isLoading: false });
				if (!responseData.IsSucceeded) {
					this.props.showMessage("error", "Error", responseData.ErrorDescription);
					return;
				}
				if (responseData.Item !== null) {
					this.setState({ list: responseData.Item, reEmbossList: [] });
				}
			},
			(error) => {
				this.setState({ isLoading: false });
				this.props.showMessage("error", "Error", error);
			}
		);

	}

	Validate = () => {
		const { model, vModel } = this.state;
		const { showValidationErrors } = this.props;

		var errorList = [];

		if (!model.UniqueClientId) {
			errorList.push("Select the Client to continue.");
			vModel.UniqueClientId = true;
		}
		else
			vModel.UniqueClientId = false;

		if (errorList.length > 0) {
			showValidationErrors(errorList);
			return false;
		}

		return true;
	}
	RenderItemUniqueClient = (d) => {
		this.renderItemUniqueClient = `${d.UniqueClientId} - ${d.Name}`;
		return this.renderItemUniqueClient;
	}
	RenderItemCard = (d) => {
		this.renderItemCard = `${d.MaskedCardNumber} - ${d.CardEmbossName}`;
		return this.renderItemCard;
	}
	RowSelected = (index) => {
		let { model, list } = this.state;
		let StartDate = model.StartDate;
		let EndDate = model.EndDate;

		model = list[index];

		model.StartDate = StartDate;
		model.EndDate = EndDate;
		if (list[index].CardRequestId) {
			model.Id = list[index].Id;
		}
		this.setState({ isEdit: true, model, index });
	}

	GetProductParameter = () => {
		this.parameterProduct.UniqueClientId = this.state.model.UniqueClientId;
		this.parameterProduct.IsNoNameProduct = this.state.model.IsNoNameCard;
		return this.parameterProduct;
	}

	FillCustomer = (customer) => {
		this.HandleChange("Customer", customer);
	}

	CancelSelectCallback = () => {
		this.setState({
			isDialogOpen: false,
			isDisputeDialogOpen: false,
			isReEmbossDialogOpen: false,
			isReasonReEmbossDialogOpen: false
		});
	};


	HandleSubmit = async () => {
		const { ExecuteApiPost } = this.props;

		let { model, list } = this.state;

		var result = await ExecuteApiPost("/prepaidapi/v1.0/CardRequest/ReEmbossIncorrectEmbossCard", {
			CardRequestDataList: list,
			UniqueClientId: model.UniqueClientId
		});
		if (result != null) {
			this.setState({ reReasonEmbosList: result, isReasonReEmbossDialogOpen: true })
		}
	}
	HandleReEmboss = () => {
		this.setState({ isReEmbossDialogOpen: true });
	}
	render() {
		const { Disabled } = this.props;
		const { alert, model, vModel, list, isLoading, index } = this.state;

		var IsClient = ClientHelper.IsClient();

		return (
			<div>
				<LoadingComponent Show={isLoading} />

				{alert}
				<ButtonToolbar ButtonList={[
					{ Code: "Search", OnClick: this.HandleSearch, Disabled: Disabled },
					{ Code: "Clear", OnClick: this.HandleClear, Disabled: Disabled },
					{ Code: "Submit", OnClick: this.HandleSubmit, Disabled: Disabled || this.state.list.length == 0 },

				]} menuId={this.props.menuId} ApprovalData={this.props.ApprovalData} After={this.props.After} />
				<GridContainer>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardBody>
								<GenericExpansionPanel Title="Main Panel">
									<GridItem xs={12}>
										<GridContainer>
											<GridItem xs={4}>
												<GenericSelectInput
													Name="UniqueClientId"
													LabelMd={4}
													LabelText="Client"
													Method="POST"
													Url="/bankapi/v1.0/BankCustomer/Search"
													Parameter={this.parameterUniqueClientId}
													DataRoot="Item"
													KeyValueMember="Id"
													RenderItem={this.RenderItemUniqueClient}
													Value={model.UniqueClientId}
													ValueChanged={this.HandleChange}
													CanClear
													Disabled={IsClient}
													DefaultIndex={IsClient ? 0 : -1}
													Required
													IsInvalid={vModel.UniqueClientId}
												/>
											</GridItem>

											<GridItem xs={4}>
												<GenericSelectInput
													key={[model.UniqueClientId, model.IsNoNameCard]}
													Name="ProductId"
													LabelMd={4}
													LabelText="Product"
													Method="POST"
													Url="/prepaidapi/v1.0/Product/Search"
													Parameter={this.GetProductParameter()}
													DataRoot="Item"
													KeyValueMember="Id"
													TextValueMember="ProductName"
													Value={model.ProductId}
													ValueChanged={this.HandleChange}
												/>
											</GridItem>

											{!model.IsNoNameCard &&
												<GridItem xs={4}>
													<CustomerComponent
														key={model.UniqueClientId}
														LabelMd={4}
														CustomerNumber={model.CustomerNumber}
														HandleChange={this.HandleChange}
														FillCallback={this.FillCustomer}
														Programs={[ProgramCodes.Prepaid]}
														UniqueClientId={model.UniqueClientId}
													/>
												</GridItem>
											}
											{!model.IsNoNameCard &&

												<GridItem xs={4}>
													<GenericSelectInput
														key={model.ClientCustomerId}
														Name="CardId"
														LabelMd={4}
														LabelText="Masked Card Number"
														Method="POST"
														Url="/prepaidapi/v1.0/Card/CardSearch"
														Parameter={{
															ClientCustomerId: model.ClientCustomerId,
															CardSearchCriteria: 2
														}}
														DataRoot="Item"
														RenderItem={d => `${d.CardEmbossName} - ${d.MaskedCardNumber}`}
														KeyValueMember="CardId"
														TextValueMember="MaskedCardNumber"
														Value={model.CardId}
														ValueChanged={this.HandleChange}
													/>
												</GridItem>
											}
											<GridItem xs={4}>
												<ParameterComponent
													Name="CardIssuingReasonTypeId"
													LabelMd={4}
													LabelText="Issuing Reason Type"
													ParameterCode="CardIssuingReasonType"
													ParameterValue3="1"
													Value={model.CardIssuingReasonTypeId}
													ValueChanged={this.HandleChange}
													Disabled={false}
												/>
											</GridItem>
											<GridItem xs={4}>
												<GenericTextInput
													Name="EmbossName1"
													LabelMd={4}
													LabelText="Emboss Name"
													inputProps={this.maxLength26}
													IsText={true}
													Value={model.EmbossName1}
													ValueChanged={this.HandleChange}
												/>
											</GridItem>

											{model.IsNoNameCard &&
												<GridItem xs={4}>
													<GenericTextInput
														Name="MaskedCardNumber"
														LabelMd={4}
														Format={"@@@@@@******@@@@"}
														LabelText="Masked Card Number"
														inputProps={this.maxLength26}
														IsText={true}
														Value={model.MaskedCardNumber}
														ValueChanged={this.HandleChange}
													/>
												</GridItem>
											}
											<GridItem xs={4}>
												<GenericDateInput
													Utc
													Name="StartDate"
													LabelText="Start Date"
													Value={model.StartDate ? DateHelper.ToDateInputValue(model.StartDate) : ""}
													ValueChanged={this.HandleChange}
													IsFuture={false} />
											</GridItem>
											<GridItem xs={4}>
												<GenericDateInput
													Utc
													Name="EndDate"
													LabelText="End Date"
													Value={model.EndDate ? DateHelper.ToDateInputValue(model.EndDate) : ""}
													ValueChanged={this.HandleChange}
													MinDate={model.StartDate} />
											</GridItem>


											<GridItem xs={4}>
												<GenericTextInput
													Name="FileName"
													LabelText="File Name"
													Value={model.FileName}
													ValueChanged={this.HandleChange}
												/>
											</GridItem>

											<GridItem xs={4}>
												<GenericDateInput
													Utc
													Name="EmbossFileCreateDate"
													LabelText="EmbossFileCreateDate"
													Value={model.EmbossFileCreateDate}
													ValueChanged={this.HandleChange}
													MaxDate={DateHelper.GetLocalDateAsUtc()} />
											</GridItem>


										</GridContainer>
									</GridItem>
								</GenericExpansionPanel>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
				<GridContainer>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardHeader>
								<GenericTitle text={"Card Emboss List"} />
							</CardHeader>
							<CardBody>
								<GridContainer>
									<GridItem xs={4}>
									</GridItem>
									<GridItem xs={8} />
								</GridContainer>
								<GridContainer spacing={16}>
									<GridItem xs={12}>
										<GenericGrid
											Data={list}
											Columns={this.Columns}
											ProgramCode={ProgramCodes.Prepaid}
											ShowPagination={true}
											PageSize={100} />
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>



				<GenericDialog open={this.state.isDialogOpen} onBackdropClick={this.CancelSelectCallback} maxWidth="sm" fullWidth keepMounted={true} style={{ zIndex: 8 }} >
					<DialogTitle><GenericLabel FontSize="16px" Text="Payment Code" Bold={true} />
					</DialogTitle>

					<DialogContent>
						<img style={{ width: 300, height: 300, marginLeft: "114px", display: "inline-block" }} src={"data:image/png;base64," + model.QrCode}
						/>
					</DialogContent>
					<GenericDialogActions>
						<Button size="sm" onClick={this.CancelSelectCallback}>Cancel</Button>
					</GenericDialogActions>
				</GenericDialog>

				<GenericDialog open={this.state.isReasonReEmbossDialogOpen} onBackdropClick={this.CancelSelectCallback} maxWidth="lg" fullWidth keepMounted={true} style={{ zIndex: 8 }} >
					<DialogTitle><GenericLabel FontSize="16px" Text="Detail" Bold={true} />
					</DialogTitle>

					<DialogContent>
						<GridContainer spacing={16}>
							<GridItem xs={12}>
								<GenericGrid
									Data={this.state.reReasonEmbosList}
									Columns={this.ReasonEmbossColumns}
									SelectedIndex={index}
									ProgramCode={ProgramCodes.Prepaid}
									ShowPagination={true}
									PageSize={100} />
							</GridItem>
						</GridContainer>
					</DialogContent>
					<GenericDialogActions>
						<Button size="sm" onClick={this.CancelSelectCallback}>Cancel</Button>

					</GenericDialogActions>
				</GenericDialog>
			</div >
		);
	}
}

IncorrectEmbossCards.propTypes = {
	classes: PropTypes.object.isRequired,
	Disabled: PropTypes.bool
};

export default withArtifex(IncorrectEmbossCards, {});